import { isPhone } from '@helpers';
import { MachinesScreen, MetricTypeLink } from '@v2/pages/machines/common/enums';
import PerformanceActive from '@v2/pages/performance/screens/PerformanceActive';
import PerformancePaid from '@v2/pages/performance/screens/PerformancePaid';
import PerformanceProductive from '@v2/pages/performance/screens/PerformanceProductive';
import PerformanceUtilization from '@v2/pages/performance/screens/PerformanceUtilization';

export const PERFORMANCE_MAIN_SCREEN = 'Performance';

export const performanceLinking = {
  path: 'performance',
  screens: {
    [`${PERFORMANCE_MAIN_SCREEN}${MachinesScreen.ACTIVE}`]: MetricTypeLink.ACTIVE,
    [`${PERFORMANCE_MAIN_SCREEN}${MachinesScreen.PRODUCTIVE}`]: MetricTypeLink.PRODUCTIVE,
    [`${PERFORMANCE_MAIN_SCREEN}${MachinesScreen.UTILIZATION}`]: MetricTypeLink.UTILIZATION,
    [`${PERFORMANCE_MAIN_SCREEN}${MachinesScreen.PAID}`]: MetricTypeLink.PAID,
  },
};

export const performanceConfig = [
  {
    name: `${PERFORMANCE_MAIN_SCREEN}${MachinesScreen.ACTIVE}`,
    Component: PerformanceActive,
  },
  { name: `${PERFORMANCE_MAIN_SCREEN}${MachinesScreen.PRODUCTIVE}`, Component: PerformanceProductive },
  { name: `${PERFORMANCE_MAIN_SCREEN}${MachinesScreen.UTILIZATION}`, Component: PerformanceUtilization },
  { name: `${PERFORMANCE_MAIN_SCREEN}${MachinesScreen.PAID}`, Component: PerformancePaid },
];
